import React from 'react';
import { connect } from 'react-redux';
import styles from './data-card.module.scss';
import DataCardRow from '../../components/data-card-row';
import { dataMapper, dataComparisonMapper } from '../../helpers/data-mapper';
import { findDOMNode } from 'react-dom';
import ScrollToComponent from '../../helpers/scroll-to-component';
import * as selectors from '../../reducers';
import PropTypes from 'prop-types';
import { colorMatcher } from '../../helpers/formatters';

class DataCard extends React.Component {
  constructor() {
    super();
    this.rows = {};
    this.state = {
      expanded: false,
      expandable: true,
      heights: {
        collapsed: 520,
        expanded: 5000,
      },
    };
    this.handleExpandClick = this.handleExpandClick.bind(this);
  }

  redrawCards() {
    const { isMobile, activeEntity } = this.props;
    const expandable = Object.keys(this.rows).length > 1;
    let expanded = this.cardElement.scrollHeight * 1.15; // add a bit extra to account for non-chrome browsers
    let whichRow = this.rows[0];
    const node = findDOMNode(whichRow)
      ? findDOMNode(whichRow).querySelectorAll('.barChart')[1] || null
      : null;

    let offset = 10;
    if (!isMobile) {
      // :(
      const marginTop = node
        ? parseInt(window.getComputedStyle(node).marginTop, 10)
        : 0;
      offset =
        offset +
        (node ? node.scrollHeight : 0) +
        marginTop +
        (activeEntity.entityCategory.includes('Other') ? 0 : 60);
    }

    const collapsed = (node ? node.offsetTop : 300) + offset;

    this.setState({
      heights: {
        expanded,
        collapsed,
      },
    });
    if (!expandable) {
      this.setState({
        expanded: true,
        expandable: false,
      });
    }
  }

  componentDidUpdate(prevProps) {
    // We need to redraw the cards with their new heights when
    // we switch from comparison to single view.
    if (prevProps.comparedEntity && !this.props.comparedEntity) {
      this.redrawCards();
    }
  }

  componentDidMount() {
    this.redrawCards();
  }

  buildRowArray(id) {
    const { activeEntity, entities } = this.props;
    const sameCategoryEntities = entities.filter(
      (entity) => entity.entityCategory === activeEntity.entityCategory
    );

    return dataMapper({
      activeEntity: activeEntity[id],
      classification: sameCategoryEntities.map((entity) => entity[id]),
      state: sameCategoryEntities.map((entity) => entity[id]),
    });
  }

  buildRowArrayForComparison(id) {
    const { activeEntity, comparedEntity, entities } = this.props;

    const classification = entities.filter((council) => {
      return (
        (council.entityCategory === activeEntity.entityCategory ||
          council.entityCategory === comparedEntity.entityCategory) &&
        !council.isBlank
      );
    });
    const statesCouncils = entities.filter((council) => !council.isBlank);

    return dataComparisonMapper({
      activeEntity: activeEntity[id],
      comparedEntity: comparedEntity[id],
      classification: classification.map((council) => council[id]),
      state: statesCouncils.map((council) => council[id]),
    });
  }

  renderDataCardRows(id, color, label) {
    const { comparedEntity } = this.props;
    const { expanded, expandable } = this.state;
    const rowData = comparedEntity
      ? this.buildRowArrayForComparison(id)
      : this.buildRowArray(id);
    const howManyRowsToShow = expandable ? (expanded ? 9999 : 1) : 1;

    return rowData.length ? (
      <div className={'data-card-row-container'}>
        {rowData.map((row, i) => {
          return (
            <DataCardRow
              key={i + color}
              data={row}
              color={color}
              revealed={i < howManyRowsToShow}
              ref={(r) => (this.rows[i] = r)}
              cardTitle={label}
              isCardExpanded={expanded}
            />
          );
        })}
      </div>
    ) : null;
  }

  renderExpandButton() {
    return (
      <div
        className={styles.dataCardExpandContainer}
        onClick={this.handleExpandClick}
        data-expanded={this.state.expanded}
        data-expandable={this.state.expandable}
        data-color={this.props.color}
      >
        <button type="button" className={styles.dataCardExpandContainerButton}>
          {this.state.expanded ? 'Hide breakdown -' : 'View breakdown +'}
        </button>
      </div>
    );
  }

  handleExpandClick() {
    const { expanded, expandable } = this.state;
    if (expandable) {
      // We're now opening, let's scroll
      if (!expanded) {
        ScrollToComponent(this);
      } else {
        ScrollToComponent(this, true);
      }
      this.setState({
        expanded: !expanded,
      });
    }
  }

  render() {
    const { id, color, label } = this.props;
    const { expanded, expandable, heights } = this.state;
    const cardHeight = expanded ? heights.expanded : heights.collapsed;

    let transitionTime = expanded
      ? heights.expanded * 0.2
      : heights.expanded * 0.1;
    let transition = `max-height ${transitionTime}ms`;
    return (
      <div
        className={styles.dataCard}
        style={{ maxHeight: cardHeight, transition }}
        ref={(r) => (this.cardElement = r)}
        data-expanded={expanded}
        data-expandable={expandable}
        data-color={color}
      >
        <div className={styles.dataCardHeader}>
          {label}
          <hr
            className={styles.line}
            style={{ background: colorMatcher(color) }}
          />
        </div>

        {this.renderDataCardRows(id, color, label)}
        {this.renderExpandButton()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  activeEntity: selectors.getActiveEntity(state),
  comparedEntity: selectors.getComparedEntity(state),
  entities: selectors.getEntities(state),
  isMobile: selectors.getIsMobile(state),
});

DataCard.propTypes = {
  activeEntity: PropTypes.object.isRequired,
  comparedEntity: PropTypes.object,
  id: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, null)(DataCard);



// WEBPACK FOOTER //
// ./src/components/data-card/data-card.js